import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  Checkbox,
  ListItem,
  Text,
  UnorderedList,
} from '@chakra-ui/react';
import { FC, useEffect, useRef, useState } from 'react';
import { ArquivoDeMidia } from '../models';
import { descreverUso, estaEmUso } from '../utils';

interface Props {
  // um arquivo = exclusão unitária; vários = lote de não usadas
  arquivos: ArquivoDeMidia[];
  isOpen: boolean;
  carregando: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const ModalApagar: FC<Props> = ({
  arquivos,
  isOpen,
  carregando,
  onClose,
  onConfirm,
}) => {
  const cancelRef = useRef<HTMLButtonElement>(null);
  const [entendeuRisco, setEntendeuRisco] = useState(false);

  useEffect(() => {
    if (isOpen) setEntendeuRisco(false);
  }, [isOpen]);

  const ehLote = arquivos.length > 1;
  const [arquivo] = arquivos;
  const exigeConfirmacaoForte =
    !ehLote && !!arquivo && estaEmUso(arquivo.usadoEm);

  const titulo = (() => {
    if (ehLote) return `Apagar ${arquivos.length} imagens não usadas?`;
    if (exigeConfirmacaoForte) return '⚠️ Esta imagem está no ar';
    return 'Apagar imagem?';
  })();

  return (
    <AlertDialog
      isOpen={isOpen}
      onClose={onClose}
      leastDestructiveRef={cancelRef}
      isCentered
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader
            fontSize="lg"
            fontWeight="bold"
            color={exigeConfirmacaoForte ? 'white' : undefined}
            bg={exigeConfirmacaoForte ? 'red.500' : undefined}
            borderTopRadius="md"
          >
            {titulo}
          </AlertDialogHeader>

          <AlertDialogBody>
            {ehLote && (
              <Text>
                Nenhuma delas é usada pelo CMS. Elas serão apagadas do banco e
                do armazenamento. Esta ação não pode ser desfeita.
              </Text>
            )}

            {!ehLote && arquivo && !exigeConfirmacaoForte && (
              <Text>
                <b>{arquivo.nomeOriginal}</b> não é usada pelo CMS e será
                apagada. Esta ação não pode ser desfeita.
              </Text>
            )}

            {exigeConfirmacaoForte && arquivo && (
              <>
                <Text mb={2}>
                  <b>{arquivo.nomeOriginal}</b> aparece em:
                </Text>
                <UnorderedList mb={4}>
                  {descreverUso(arquivo.usadoEm).map(uso => (
                    <ListItem key={uso}>{uso}</ListItem>
                  ))}
                </UnorderedList>
                <Text mb={4}>
                  Ao apagar, esses lugares ficam <b>sem imagem no app</b> até
                  alguém enviar outra. Esta ação não pode ser desfeita.
                </Text>
                <Checkbox
                  colorScheme="red"
                  isChecked={entendeuRisco}
                  onChange={evento => setEntendeuRisco(evento.target.checked)}
                >
                  Entendo, quero apagar
                </Checkbox>
              </>
            )}
          </AlertDialogBody>

          <AlertDialogFooter>
            <Button ref={cancelRef} onClick={onClose} isDisabled={carregando}>
              Cancelar
            </Button>
            <Button
              colorScheme="red"
              ml={3}
              onClick={onConfirm}
              isLoading={carregando}
              isDisabled={exigeConfirmacaoForte && !entendeuRisco}
            >
              Apagar
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};

export default ModalApagar;
